module.exports = __webpack_public_path__ + "static/about-1-ce1f1daf751f8b58afda4d2f3ce30581.jpg";